import React from 'react'
import EmploymentEntry from './EmploymentEntry'
import { EmploymentHistoryContext } from './EmploymentHistoryContext'
import { isValidCompleteEntry } from './EmploymentHistoryValidation'
import QuestionKey from '../../../Questions/question-key'
import QuestionComponentProps from '../../../Questions/question-component-props'
import { HistoryQuestion } from '../HistoryEntry/HistoryQuestion'

const CardlessEmploymentHistoryQuestion = (props: QuestionComponentProps) => {
  const {
    updateFollowingPrefillStep,
    ...restProps
  } = props

  return (
    <HistoryQuestion
      {...restProps}
      questionKey={QuestionKey.EMPLOYMENT_HISTORY}
      HistoryContext={EmploymentHistoryContext}
      EntryComponent={EmploymentEntry}
      minimumYearsHistoryRequired={2}
      entryValidator={isValidCompleteEntry}
      updateFollowingPrefillStep={updateFollowingPrefillStep}
    />
  )
}

export default CardlessEmploymentHistoryQuestion
